// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_OT7","newExpiryDate":"styles_newExpiryDate__9Z2cJ","footer":"styles_footer__13MZv"};